import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Instagram, X } from 'lucide-react';
const whatsappUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+El+Matambrito+🍖';
const menuItems = [{
  emoji: '🍖',
  name: 'Parrilla completa',
  note: '(preguntar en caja o por WhatsApp qué cortes incluye)',
  prices: [{
    label: 'Por Kg',
    price: '$50.000'
  }]
}, {
  emoji: '🌭',
  name: 'Super Pancho Completo',
  prices: [{
    label: 'Solo',
    price: '$5.000'
  }, {
    label: 'Promo (con papas + gaseosa)',
    price: '$9.000'
  }]
}, {
  emoji: '🍔',
  name: 'Hamburguesa Paty Súper Completa',
  prices: [{
    label: 'Solo',
    price: '$7.000'
  }, {
    label: 'Promo',
    price: '$11.000'
  }]
}, {
  emoji: '🍔',
  name: 'Hamburguesa Doble Carne Paladini Completa',
  prices: [{
    label: 'Solo',
    price: '$13.000'
  }, {
    label: 'Promo',
    price: '$17.000'
  }]
}, {
  emoji: '🥩',
  name: 'Bife de Chorizo Paladini Completo',
  prices: [{
    label: 'Solo',
    price: '$7.000'
  }, {
    label: 'Promo',
    price: '$11.000'
  }]
}, {
  emoji: '🥩',
  name: 'Bife de Chori de Campo Completo',
  prices: [{
    label: 'Solo',
    price: '$7.000'
  }, {
    label: 'Promo',
    price: '$11.000'
  }]
}, {
  emoji: '🍗',
  name: 'Suprema Completa',
  prices: [{
    label: 'Solo',
    price: '$10.000'
  }, {
    label: 'Promo',
    price: '$14.000'
  }]
}, {
  emoji: '🍖',
  name: 'Milanesa de Carne Completa',
  prices: [{
    label: 'Solo',
    price: '$10.000'
  }, {
    label: 'Promo',
    price: '$14.000'
  }]
}, {
  emoji: '🍖',
  name: 'Bondiolita Completa',
  prices: [{
    label: 'Solo',
    price: '$13.000'
  }, {
    label: 'Promo',
    price: '$17.000'
  }]
}, {
  emoji: '🔥',
  name: 'Matambrito Completo',
  prices: [{
    label: 'Solo',
    price: '$13.000'
  }, {
    label: 'Promo',
    price: '$17.000'
  }]
}, {
  emoji: '🥪',
  name: 'Lomito Completo',
  prices: [{
    label: 'Solo',
    price: '$13.000'
  }, {
    label: 'Promo',
    price: '$17.000'
  }]
}, {
  emoji: '🥗',
  name: 'Sandwich Vegetariano Completo',
  prices: [{
    label: 'Solo',
    price: '$10.000'
  }, {
    label: 'Promo',
    price: '$14.000'
  }]
}];
const allegraMenuItems = [{
  name: 'Chocotorta',
  price: '$8.000'
}, {
  name: 'Oreo',
  price: '$8.000'
}, {
  name: 'Chajá',
  price: '$8.000'
}, {
  name: 'Tiramisú',
  price: '$8.000'
}, {
  name: 'Cheesecake',
  price: '$8.000'
}, {
  name: 'Lemon Pie',
  price: 'Consultar'
}, {
  name: 'Cadbury',
  price: 'Consultar'
}, {
  name: 'Matilda',
  price: 'Consultar'
}, {
  name: 'Flan',
  price: '$3.000'
}, {
  name: 'Infusión + 2 media lunas',
  price: '$4.500'
}, {
  name: 'Infusión + tostadas',
  price: '$5.500'
}, {
  name: 'Infusión + tostado',
  price: '$7.000'
}, {
  name: 'Postrecitos (chocotorta, oreo, tiramisú)',
  price: '$8.000'
}, {
  name: 'Porción de torta',
  price: '$8.000'
}, {
  name: 'Infusión + porción de torta',
  price: '$13.000'
}];
const barTragos = [{
  name: 'Gin & Tonic',
  note: 'clásico – frutos rojos – limón – frutilla – naranja',
  price: '$9.000'
}, {
  name: 'Ramazzoti',
  note: 'cachaca, tónica',
  price: '$8.000'
}, {
  name: 'Daiquiri',
  note: 'vodka, frutilla, durazno, ananá, frutos rojos',
  price: '$9.000'
}, {
  name: 'Sex on the Beach',
  note: 'vodka, jugo de naranja, granadina, limón',
  price: '$9.000'
}, {
  name: 'Aperol Spritz',
  note: 'aperol, espumante, soda, naranja',
  price: '$10.000'
}, {
  name: 'Tom Collins',
  note: 'gin, jugo de limón, soda',
  price: '$8.000'
}, {
  name: 'Caipiruva',
  note: 'vino, lima, azúcar, jugo de manzana',
  price: '$9.000'
}, {
  name: 'Negroni',
  note: 'ron, campari, vermouth',
  price: '$11.000'
}, {
  name: 'Caipirinha',
  note: 'cachaca, lima y gaseosa lima',
  price: '$10.000'
}, {
  name: 'Caipiroska',
  note: 'vodka, lima macerada y gaseosa lima',
  price: '$10.000'
}, {
  name: 'Cuba Libre',
  note: 'ron, coca cola, limón',
  price: '$8.000'
}, {
  name: 'Destornillador',
  note: 'vodka + jugo de naranja',
  price: '$9.000'
}, {
  name: 'Tequila Sunrise',
  note: 'tequila, granadina, jugo de naranja',
  price: '$10.000'
}, {
  name: 'Sea Breeze',
  note: 'vodka, frutos del bosque, lima, pomelo',
  price: '$9.000'
}];
const barClasicos = [{
  name: 'Fernet',
  price: '$7.000'
}, {
  name: 'Gancia / Batido',
  price: '$7.000 / $8.000'
}, {
  name: 'Campari',
  price: '$8.000'
}, {
  name: 'Sangría',
  price: '$9.000'
}, {
  name: 'Martini',
  price: '$7.000'
}, {
  name: 'Vermouth',
  price: '$7.000'
}, {
  name: 'Cerveza',
  price: '$5.000 / $7.000'
}, {
  name: 'Vinos',
  price: 'Consultar'
}, {
  name: 'Espumantes',
  price: 'Consultar'
}];
const barSinAlcohol = [{
  name: 'Licuado Frutal',
  price: '$7.000'
}, {
  name: 'Milkshake',
  price: '$7.000'
}, {
  name: 'Limonada en Jarra',
  price: '$9.000'
}, {
  name: 'Frozen',
  price: 'Consultar'
}, {
  name: 'Jugo de Naranja',
  price: '$9.000'
}, {
  name: 'Helados de Bocha',
  price: '$4.000'
}];
export function Spaces() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [allegraMenuOpen, setAllegraMenuOpen] = useState(false);
  const [barMenuOpen, setBarMenuOpen] = useState(false);
  return <section id="espacios" className="py-24 bg-matambrito-black relative" data-id="element-350">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-352">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-353">
            Tres espacios,{' '}
            <span className="text-matambrito-gold" data-id="element-354">una sola experiencia</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-matambrito-beige font-light" data-id="element-355">
            Cada rincón del Matambrito tiene su propia personalidad. Todos
            tienen el mismo calor.
          </motion.p>
        </div>

        <div className="space-y-24" data-id="element-356">
          {/* Block 1: La Parrilla */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-357">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="order-2 lg:order-1" data-id="element-358">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-matambrito-cream mb-6" data-id="element-359">
                La Parrilla
              </h3>
              <p className="text-lg text-matambrito-beige leading-relaxed mb-8 font-light" data-id="element-360">
                Acá es donde empieza todo. El humo, el olor a brasa, los
                sándwiches que salen enormes y las parrilladas que se comparten.
                Sabores caseros, cortes nobles y porciones que no te dejan con
                hambre.
              </p>
              <button onClick={() => setMenuOpen(true)} className="inline-block bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white px-8 py-3 rounded-md font-medium transition-colors cursor-pointer" data-id="element-361">
                Ver el menú de parrilla
              </button>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="order-1 lg:order-2 aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-362">
              <img src="https://cdn.magicpatterns.com/uploads/fDvjnHMk3PMDuqZExqgubA/WhatsApp_Image_2026-04-23_at_18.35.02.jpg" alt="La Parrilla de El Matambrito" className="w-full h-auto object-contain" data-id="element-363" />
            </motion.div>
          </div>

          {/* Block 2: La Barra */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-364">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-365">
              <img src="https://cdn.magicpatterns.com/uploads/rbwN7VCm1ttugsaxLsQ3Xx/barra-real.jpg" alt="La Barra de Tragos" className="w-full h-full object-cover" data-id="element-366" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} data-id="element-367">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-matambrito-cream mb-6" data-id="element-368">
                La Barra
              </h3>
              <p className="text-lg text-matambrito-beige leading-relaxed mb-8 font-light" data-id="element-369">
                Cuando cae la noche, la barra toma protagonismo. Tragos bien
                preparados, cervezas heladas y opciones para todos. Un espacio
                pensado para que la noche fluya tranquila, con buena compañía y
                sin apuro.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-370">
                <button onClick={() => setBarMenuOpen(true)} className="bg-white/10 hover:bg-white/20 text-matambrito-cream px-8 py-3 rounded-md font-medium transition-colors cursor-pointer" data-id="element-371">
                  Consultar la carta de tragos
                </button>
                <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-matambrito-beige hover:text-matambrito-gold transition-colors px-4 py-3" data-id="element-372">
                  <Instagram className="w-5 h-5" data-id="element-373" />
                  @elmatambritovgg
                </a>
              </div>
            </motion.div>
          </div>

          {/* Block 3: Allegra Café */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center bg-matambrito-alegra/5 rounded-3xl p-6 lg:p-12 border border-matambrito-alegra/20" data-id="element-374">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="order-2 lg:order-1" data-id="element-375">
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-matambrito-alegra mb-6" data-id="element-376">
                Allegra Café & Pastelería
              </h3>
              <p className="text-lg text-matambrito-cream/90 leading-relaxed mb-8 font-light" data-id="element-377">
                Un container celeste lleno de luz, plantas y dulzura. Allegra es
                el rincón de las tardes: café bien preparado, tortas caseras y
                pastelería artesanal. Para los que llegan temprano, para los que
                necesitan una pausa, para los que simplemente quieren algo rico
                con alguien especial.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-378">
                <button onClick={() => setAllegraMenuOpen(true)} className="bg-matambrito-alegra hover:bg-[#4a9e9e] text-white px-8 py-3 rounded-md font-medium transition-colors cursor-pointer" data-id="element-379">
                  Menú de meriendas
                </button>
                <a href="https://instagram.com/coffe_allegra" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-matambrito-alegra hover:text-white transition-colors px-4 py-3" data-id="element-380">
                  <Instagram className="w-5 h-5" data-id="element-381" />
                  @coffe_allegra
                </a>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="order-1 lg:order-2 aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl border-4 border-matambrito-alegra/20" data-id="element-382">
              <img src="https://cdn.magicpatterns.com/uploads/nT8pVpmaDQsdTpmYrHJ2zK/WhatsApp_Image_2026-04-14_at_16.23.44.jpg" alt="Allegra Café" className="w-full h-full object-cover" data-id="element-383" />
            </motion.div>
          </div>
        </div>
      </div>

      {/* Menu Modal - El Matambrito */}
      <AnimatePresence data-id="element-384">
        {menuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setMenuOpen(false)} data-id="element-385">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-matambrito-charcoal border border-matambrito-red-dark/40 rounded-2xl w-full max-w-lg max-h-[85vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-386">
              {/* Header */}
              <div className="sticky top-0 z-10 bg-matambrito-charcoal border-b border-matambrito-red-dark/30 px-6 py-5 flex items-center justify-between" data-id="element-387">
                <div data-id="element-388">
                  <h3 className="text-2xl font-serif font-bold text-matambrito-cream" data-id="element-389">
                    🍔 Menú El Matambrito
                  </h3>
                  <p className="text-sm text-matambrito-beige/70 mt-1" data-id="element-390">
                    Todos los sándwiches vienen completos
                  </p>
                </div>
                <button onClick={() => setMenuOpen(false)} className="text-matambrito-beige/60 hover:text-matambrito-cream transition-colors p-1" data-id="element-391">
                  <X className="w-6 h-6" data-id="element-392" />
                </button>
              </div>

              {/* Menu Items */}
              <div className="overflow-y-auto max-h-[calc(85vh-140px)] px-6 py-4 space-y-1" data-id="element-393">
                {menuItems.map((item, index) => <div key={index} className="py-4 border-b border-white/5 last:border-b-0" data-id="element-394">
                    <div className="flex items-start gap-3 mb-2" data-id="element-395">
                      <span className="text-xl leading-none mt-0.5" data-id="element-396">
                        {item.emoji}
                      </span>
                      <div className="flex-1" data-id="element-397">
                        <h4 className="text-matambrito-cream font-semibold text-base" data-id="element-398">
                          {item.name}
                        </h4>
                        {item.note && <p className="text-matambrito-beige/50 text-xs mt-1 italic" data-id="element-399">
                            {item.note}
                          </p>}
                      </div>
                    </div>
                    <div className="ml-9 space-y-1" data-id="element-400">
                      {item.prices.map((p, i) => <div key={i} className="flex items-center justify-between text-sm" data-id="element-401">
                          <span className="text-matambrito-beige/80" data-id="element-402">
                            {p.label}
                          </span>
                          <span className="text-matambrito-gold font-bold" data-id="element-403">
                            {p.price}
                          </span>
                        </div>)}
                    </div>
                  </div>)}
              </div>

              {/* Footer */}
              <div className="sticky bottom-0 bg-matambrito-charcoal border-t border-matambrito-red-dark/30 px-6 py-4" data-id="element-404">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white py-3 rounded-md font-medium transition-colors" data-id="element-405">
                  Hacer pedido por WhatsApp
                </a>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Menu Modal - La Barra */}
      <AnimatePresence data-id="element-406">
        {barMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setBarMenuOpen(false)} data-id="element-407">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-[#0a2e2e] border border-teal-600/30 rounded-2xl w-full max-w-lg max-h-[90vh] flex flex-col overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-408">
              {/* Header */}
              <div className="bg-gradient-to-r from-[#0a2e2e] to-[#0d3a3a] border-b border-teal-600/20 px-6 py-5 flex items-center justify-between shrink-0" data-id="element-409">
                <div data-id="element-410">
                  <h3 className="text-2xl font-serif font-bold text-white" data-id="element-411">
                    🍸 Carta de Tragos
                  </h3>
                  <p className="text-sm text-teal-300/70 mt-1" data-id="element-412">
                    La Barra · El Matambrito
                  </p>
                </div>
                <button onClick={() => setBarMenuOpen(false)} className="text-teal-300/60 hover:text-white transition-colors p-1" data-id="element-413">
                  <X className="w-6 h-6" data-id="element-414" />
                </button>
              </div>

              {/* Menu Items */}
              <div className="overflow-y-auto flex-1 px-6 py-4" data-id="element-415">
                {/* Tragos Section */}
                <h4 className="text-teal-400 font-bold text-sm tracking-widest mb-4 flex items-center gap-2" data-id="element-416">
                  🍹 TRAGOS
                </h4>
                <div className="space-y-1 mb-6" data-id="element-417">
                  {barTragos.map((item, index) => <div key={index} className="py-3 border-b border-teal-600/10 last:border-b-0" data-id="element-418">
                      <div className="flex items-center justify-between" data-id="element-419">
                        <span className="text-white font-medium" data-id="element-420">
                          {item.name}
                        </span>
                        <span className="text-amber-400 font-bold" data-id="element-421">
                          {item.price}
                        </span>
                      </div>
                      {item.note && <p className="text-teal-300/50 text-xs mt-1 italic" data-id="element-422">
                          {item.note}
                        </p>}
                    </div>)}
                </div>

                {/* Divider */}
                <div className="border-t border-teal-600/20 my-4" data-id="element-423"></div>

                {/* Clásicos Section */}
                <h4 className="text-teal-400 font-bold text-sm tracking-widest mb-4 flex items-center gap-2" data-id="element-424">
                  🥃 CLÁSICOS
                </h4>
                <div className="space-y-1 mb-6" data-id="element-425">
                  {barClasicos.map((item, index) => <div key={index} className="py-2.5 border-b border-teal-600/10 last:border-b-0 flex items-center justify-between" data-id="element-426">
                      <span className="text-white font-medium" data-id="element-427">
                        {item.name}
                      </span>
                      <span className="text-amber-400 font-bold" data-id="element-428">
                        {item.price}
                      </span>
                    </div>)}
                </div>

                {/* Divider */}
                <div className="border-t border-teal-600/20 my-4" data-id="element-429"></div>

                {/* Sin Alcohol Section */}
                <h4 className="text-teal-400 font-bold text-sm tracking-widest mb-4 flex items-center gap-2" data-id="element-430">
                  🧃 SIN ALCOHOL
                </h4>
                <div className="space-y-1 pb-2" data-id="element-431">
                  {barSinAlcohol.map((item, index) => <div key={index} className="py-2.5 border-b border-teal-600/10 last:border-b-0 flex items-center justify-between" data-id="element-432">
                      <span className="text-white font-medium" data-id="element-433">
                        {item.name}
                      </span>
                      <span className="text-amber-400 font-bold" data-id="element-434">
                        {item.price}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Footer */}
              <div className="bg-[#0a2e2e] border-t border-teal-600/20 px-6 py-4 shrink-0" data-id="element-435">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-teal-600 hover:bg-teal-700 text-white py-3 rounded-md font-medium transition-colors" data-id="element-436">
                  Reservar mesa por WhatsApp
                </a>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Menu Modal - Allegra Café */}
      <AnimatePresence data-id="element-437">
        {allegraMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setAllegraMenuOpen(false)} data-id="element-438">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-[#f0fafa] border border-matambrito-alegra/40 rounded-2xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-2xl flex flex-col" onClick={e => e.stopPropagation()} data-id="element-439">
              {/* Header */}
              <div className="bg-matambrito-alegra px-6 py-5 flex items-center justify-between shrink-0" data-id="element-440">
                <div data-id="element-441">
                  <h3 className="text-2xl font-serif font-bold text-white" data-id="element-442">
                    🍰 Postres Individuales
                  </h3>
                  <p className="text-sm text-white/80 mt-1" data-id="element-443">
                    Allegra Café & Pastelería
                  </p>
                </div>
                <button onClick={() => setAllegraMenuOpen(false)} className="text-white/70 hover:text-white transition-colors p-1" data-id="element-444">
                  <X className="w-6 h-6" data-id="element-445" />
                </button>
              </div>

              {/* Menu Items */}
              <div className="overflow-y-auto flex-1 px-6 py-4 pb-8 space-y-1" data-id="element-446">
                {allegraMenuItems.map((item, index) => <div key={index} className="py-3.5 border-b border-matambrito-alegra/10 last:border-b-0 flex items-center justify-between" data-id="element-447">
                    <div className="flex items-center gap-3" data-id="element-448">
                      <span className="text-lg" data-id="element-449">🍰</span>
                      <span className="text-gray-800 font-medium" data-id="element-450">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-matambrito-alegra font-bold text-lg" data-id="element-451">
                      {item.price}
                    </span>
                  </div>)}
              </div>

              {/* Footer */}
              <div className="bg-[#f0fafa] border-t border-matambrito-alegra/20 px-6 py-4 shrink-0" data-id="element-452">
                <a href="https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+Allegra+Café+☕" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-matambrito-alegra hover:bg-[#4a9e9e] text-white py-3 rounded-md font-medium transition-colors" data-id="element-453">
                  Consultar por WhatsApp
                </a>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}